import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, FileText } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const nowMonth = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

const monthOptions = () => {
  const list = [];
  const d = new Date();
  d.setDate(1);
  for (let i = 0; i < 6; i++) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const label = d.toLocaleDateString(undefined, { month: "short", year: "numeric" });
    list.push({ value: `${y}-${m}`, label });
    d.setMonth(d.getMonth() - 1);
  }
  return list;
};

export default function VendorStatementButton() {
  const { apiBase, authHeader, user } = useAuth();
  const [month, setMonth] = useState(nowMonth());
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      const resp = await axios.get(
        `${apiBase}/vendor/payouts/${month}/statement`,
        { headers: authHeader(), responseType: "blob" },
      );
      const blob = new Blob([resp.data], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      const safe = (user?.name || "partner").toLowerCase().replace(/\s+/g, "-");
      a.download = `sriman-payout-${month}-${safe}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (err) {
      toast.error("Failed to generate statement");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="hidden md:inline-flex items-center gap-2">
      <select
        data-testid="vendor-statement-month"
        value={month}
        onChange={(e) => setMonth(e.target.value)}
        className="bg-transparent border border-white/15 hover:border-red-500 text-white text-xs px-2.5 py-2 rounded-sm focus:outline-none"
      >
        {monthOptions().map((m) => (
          <option key={m.value} value={m.value} className="bg-[#0B132B]">
            {m.label}
          </option>
        ))}
      </select>
      <button
        onClick={download}
        disabled={busy}
        data-testid="vendor-statement-download"
        className="inline-flex items-center gap-2 border border-white/15 hover:border-red-500 text-white text-xs font-medium px-3 py-2 rounded-sm transition-colors disabled:opacity-60"
      >
        {busy ? <Loader2 size={14} className="animate-spin" /> : <FileText size={14} />}
        Statement
      </button>
    </div>
  );
}
